export default __webpack_public_path__ + "static/media/icon-menu-master-data.48582744.svg";